<template>
  <v-container
    tag="section"
  >
    <base-material-card
      :color="color"
      icon="notes"
      inline
      class="px-5 py-3"
    >
      <template
        v-slot:after-heading
      >
        <div class="text-h2 font-weight-light">
          {{ entity.type }} | {{ entity.created_at }}
        </div>
      </template>
      <v-container class="py-0">
        <v-col
          cols="12"
        >
          <base-material-card
            :color="color"
            inline
            class="px-5 py-3"
            :title="$t('information')"
          >
            <v-data-iterator
              hide-default-footer
              dense
              :items="[information]"
            >
              <template v-slot:default="props">
                <v-row>
                  <v-list
                    dense
                    style="overflow: auto; width: 100%;"
                  >
                    <template
                      v-for="(info, index) in information"
                    >
                      <v-list-item
                        v-if="info.val"
                        :key="index"
                      >
                        <v-list-item-content>
                          {{ $t(info.title) }}:
                        </v-list-item-content>
                        <v-list-item-content
                          v-clipboard:copy="info.copy && info.val"
                          :style="`${info.copy && 'cursor: pointer;'}`"
                          class="align-end"
                        >
                          {{ info.val || '-' }}
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </v-list>
                </v-row>
              </template>
            </v-data-iterator>
          </base-material-card>
        </v-col>
        <v-row>
          <v-col
            cols="6"
          >
            <base-material-card
              :color="color"
              inline
              class="px-5 py-3"
              :title="$t('request')"
            >
              <pre style="white-space: pre-wrap;">{{ formatter(entity.request) }}</pre>
            </base-material-card>
          </v-col>
          <v-col
            cols="6"
          >
            <base-material-card
              :color="color"
              inline
              class="px-5 py-3"
              :title="$t('response')"
            >
              <pre style="white-space: pre-wrap;">{{ formatter(entity.response) }}</pre>
            </base-material-card>
          </v-col>
        </v-row>
      </v-container>´
    </base-material-card>
    <base-loading-overlay :loading="loading" />
  </v-container>
</template>
<script>
  import Edit from '@/mixins/Edit'
  import { JSON_FORMATTER } from '@/utils/helpers'

  export default {
    mixins: [Edit],
    data () {
      return {
        endpoint: 'logs/client',
        name: 'log',
        entity: { },

      }
    },
    computed: {
      color: function () {
        return !this.entity.phrase || this.entity.phrase === 'OK' ? 'green' : 'red'
      },
      information: function () {
        const { customer_id, type, service, time, phrase, requested_at, http_code, endpoint } = this.entity

        return [
          { title: 'type', val: type },
          { title: 'service', val: service },
          { title: 'http_phrase', val: phrase },
          { title: 'http_code', val: http_code },
          { title: 'duration', val: time },
          { title: 'timestamp', val: requested_at },
          { title: 'customer_id', val: customer_id },
          { title: 'endpoint', val: endpoint, copy: true },
        ]
      },
    },
    methods: {
      formatter: (t) => JSON_FORMATTER(t),
    },
  }
</script>
